export default __webpack_public_path__ + "static/media/Downloadcloudfile.ba6397e5.svg";